import JSONBigInt from 'json-bigint'

/**
 * Dashboard Widget Detail Store
 *
 * @since 2018-10-24
 * @author mk.ko
 * ---
 */

const url = {
  device: '/api/sm/devices'
}

export const state = () => ({
  detailDeviceInfo: {},
  eventLevelInfo: [],
  // 미복구 이벤트
  detailEventLogData: [],
  // 이벤트 로그 (최근 24시간)
  detailEventLogData24: [],
  detailEventLogCnt: 0
})

export const mutations = {
  setDeviceDetail (state, payload) {
    state.detailDeviceInfo = payload
  },
  setEventLevelInfo (state, payload) {
    state.eventLevelInfo = payload
  },
  setDeviceEventLogData (state, payload) {
    state.detailEventLogData = payload
  },
  setDeviceEventLogData24 (state, payload) {
    state.detailEventLogData24 = payload
  },
  setDeviceEventLogCnt (state, payload) {
    state.detailEventLogCnt = payload
  }
}

export const actions = {
  // Device Detail
  async getDeviceDetail ({ commit, state }, deviceId) {
    const { code, result } = await this.$axios.$get(url.device, {
      params: {
        device_id: deviceId
      }
    })

    if (code === 'ok' && result.length > 0) {
      const detailDeviceInfo = result[0]
      commit('setDeviceDetail', detailDeviceInfo)
    }
  },

  async getEventLevelData ({ commit }) {
    const apiUrl = '/api/sm/event-level'
    const {code, result} = await this.$axios.$get(apiUrl, {
      loading: false,
      successAlert: false
    })

    if (code === 'ok') {
      commit('setEventLevelInfo', result)
    }
  },

  // 미복구 이벤트
  async getDeviceEventLog ({ commit, state }, { deviceIdList }) {
    const apiUrl = `/api/da/dashboard/device-status/cur-event-log`
    try {
      const {code, result} = await this.$axios.$post(apiUrl, {
        device_id_list: deviceIdList
      }, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })

      if (code === 'ok') {
        commit('setDeviceEventLogData', result)
      }
    } catch (e) {
      this.$log('[Error getDeviceEventLog]: ', e)
      commit('setDeviceEventLogData', [])
    }
  },
  // 이벤트 로그 (최근 24시간)
  async getDeviceEventLog24 ({ commit, state }, { deviceIdList }) {
    const apiUrl = `/api/da/dashboard/device-status/event-log-new`
    try {
      const {code, result} = await this.$axios.$post(apiUrl, {
        device_id_list: deviceIdList,
        page_pos: 0,
        page_cnt: 10000
      }, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })

      if (code === 'ok') {
        commit('setDeviceEventLogData24', result)
      }
    } catch (e) {
      this.$log('[Error getEventLogData24]: ', e)
      commit('setDeviceEventLogData24', [])
    }
  },
  async getDeviceEventLogCnt ({ commit, state }, { deviceIdList }) {
    const apiUrl = `/api/da/dashboard/device-status/event-log-cnt`
    try {
      const {code, result} = await this.$axios.$post(apiUrl, {
        device_id_list: deviceIdList
      }, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })

      if (code === 'ok') {
        commit('setDeviceEventLogCnt', result[0].cnt)
      }
    } catch (e) {
      this.$log('[Error getEventLogDataCnt]: ', e)
      commit('setDeviceEventLogCnt', 0)
    }
  }
}

export const getters = {
}

export const strict = false
